import { CONSTANTS } from '../constants/constants';
import { HeaderBuilderOutput } from '@tme/toyota-common';

const {
	HTTP_RESPONSE_CODES: { NO_CONTENT }
} = CONSTANTS;

export class BaseService {
	// eslint-disable-next-line max-lines-per-function
	async fetch<T>({
		url,
		headers = {} as Headers,
		method = `GET`,
		body,
		credentials = `omit`,
		isTextResponse = false
	}: {
		url: string;
		headers?: Headers | HeaderBuilderOutput;
		method?: string;
		body?: string;
		credentials?: RequestCredentials;
		isTextResponse?: boolean;
	}): Promise<T> {
		const options = {
			method,
			headers,
			credentials,
			body
		} as unknown;

		const response = await fetch(url, options as RequestInit);

		if (!response.ok) {
			const error = `Error occurred when fetching request`;
			const dataObj = await response.json();
			throw {
				data: {
					status: response.status,
					detail:
						dataObj?.detail || dataObj?.data?.detail || dataObj.data
				},
				message: dataObj?.message || error
			};
		}

		if (response.status === NO_CONTENT) {
			return {} as T;
		}

		if (isTextResponse) {
			return { response } as unknown as T;
		}

		return await response.json();
	}
}
